<template><div><h1 id="teillieferung-auslosen" tabindex="-1"><a class="header-anchor" href="#teillieferung-auslosen"><span>Teillieferung auslösen</span></a></h1>
<p>Teillieferung auslösen — Manuelle Auslösung von Teillieferungen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Mit diesem Programm kann das Verhalten des Systems im Bereich Teillieferungen manuell übersteuert werden.</p>
<p>Die Funktion ist wie folgt:</p>
<p>Alle Aufträge, die bereits vor dem &quot;Verarbeitungsdatum bis&quot; hätten verarbeitet werden sollen und deren Auftragswert das &quot;Auftragstotal&quot; und mehr beträgt, werden auf Teillieferung gesetzt. Beim nächsten Fakturierungslauf werden somit die an Lager befindlichen Auftragspositionen in diesen Aufträgen für die Auslieferung aufbereitet.</p>
<h2 id="start-parameter" tabindex="-1"><a class="header-anchor" href="#start-parameter"><span>Start &amp; Parameter</span></a></h2>
<p>Pfad: Aufträge → Verarbeitungsläufe → Fakturen/Avis verarbeiten → Teillieferungen auslösen</p>
<p><strong>Parameter</strong></p>
<dl>
<dt>mit Verarbeitungsdatum bis</dt>
<dd>Verarbeitungsdatum im Auftragskopf</dd>
<dt>und Auftragstotal ab</dt>
<dd>Auftragswert im Auftragskopf</dd>
<dt>mit Artikel</dt>
<dd>zusätzliche Einschränkung nach bestimmten Artikeln, maximal Angabe von 3 Artikeln möglich</dd>
<dt>ohne Artikel</dt>
<dd>zusätzliche Einschränkung nach maximal 8 zusätzlichen Artikeln, die in den auszuwählenden Aufträgen NICHT enthalten sein dürfen.</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>N/A</p>
<h2 id="welche-daten-werden-verwendet-input" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verwendet-input"><span>Welche Daten werden verwendet? (Input)</span></a></h2>
<p>N/A</p>
<h2 id="welche-daten-werden-verandert-oder-erzeugt" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verandert-oder-erzeugt"><span>Welche Daten werden verändert oder erzeugt?</span></a></h2>
<p>N/A</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
</div></template>


